import React, { useState } from 'react'
import { DashboardDefaultContainer } from '../../dashboard-default-container'
import Header from '../Header'
import OfferLetter from './OfferLetter';
import { useLocation } from 'react-router-dom';
import { Employee } from 'src/redux/types/_employee.type';

const GenerateLetters = () => {
  const letters = [
    "Offer Letter",
    "Appointment Letter",
    "Promotion Letter",
    "Termination Letter",
  ];
  const location = useLocation();
  const employeeDetails: Employee = location.state?.details;

  //name, employee id, address, role name, amount,
  // name done, emplyee id done, address done, role done, 

  // amount, 
  // joining date,

  const [letterType, setLetterType] = useState("");
  // const [amount, setAmount] = useState("");

  return (
    <DashboardDefaultContainer>
      <Header title="Generate Letters" href='/hr'/>
      <div className="flex gap-2 justify-evenly items-center py-3">
        <div className="">
          <h2 className="mb-2">Select the Letter Type</h2>
          <select
            value={letterType}
            onChange={(e) => setLetterType(e.target.value)}
            className="border p-2 rounded-md h-9"
          >
            <option value="">Select Letter</option>
            {letters.map((letter) => (
              <option value={letter.toLowerCase()}>{letter}</option>
            ))}
          </select>
        </div>
        {/* <div className="mt-3">
          <label className="input input-bordered flex items-center gap-2">
            <input
              type="text"
              className="grow"
              placeholder="Date of the Employee"
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
            />
          </label>
        </div> */}
        {/* <div className="mt-3">
          <label className="input input-bordered flex items-center gap-2">
            <input
              type="text"
              className="grow"
              placeholder="Email of the Employee"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </label>
        </div> */}
        <div>
          <button
            className="px-3 py-2 border border-green-600 bg-green-200 rounded-lg text-lg"
            // onClick={generateLetter}
          >
            Generate Letter
          </button>
        </div>
      </div>
      <div className='mt-6'>
        <OfferLetter {...employeeDetails}/>
      </div>
    </DashboardDefaultContainer>
  );
}

export default GenerateLetters